import React, { useEffect, useState } from 'react';
import { Row, Col, Table } from 'antd';
import styled from 'styled-components';
import { Box } from '../../styles/globalStyle';
import { ButtonAnt } from '@pfmam/pfmam';
import { EditOutlined } from '@ant-design/icons';

const StyledReviewForm = styled.div`
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  h2 {
    font-size: 24px;
    margin-bottom: 16px;
  }
  p {
    font-size: 16px;
    margin-bottom: 8px;
  }
  .section-title {
    font-weight: bold;
    margin-bottom: 12px;
  }
  .section-box {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 24px; /* Add spacing between parent rows */
  }
`;

const getChangedTeamMembers = (original, updated, connectLoggedInContactId) => {
  const changed = updated.filter(updatedMember => {
    const originalMember = original.find(orig => orig.ContactId === updatedMember.ContactId);
    if (!originalMember) return true; // New member
    return Object.keys(updatedMember).some(key =>
      key !== 'ContactId' && updatedMember[key] !== originalMember[key]
    );
  });
  // Always include the row for connectLoggedInContactId if present in updated
  const mandatory = updated.find(member => String(member.ContactId) === String(connectLoggedInContactId));
  if (mandatory && !changed.some(m => String(m.ContactId) === String(connectLoggedInContactId))) {
    changed.push(mandatory);
  }
  return changed;
};


const ReviewAccountForm = ({programId,connectLoggedInContactId,accountOptions, formValues, changedMembers, setChangedMembers, teamMembersData, investmentOptions, setAccountTitleMsg, setAccountTitleStatus, setCurrentStepNumber }) => {
  useEffect(() => {
    if (Array.isArray(teamMembersData) && Array.isArray(formValues.accountTeamMembers)) {
      const changed = getChangedTeamMembers(teamMembersData, formValues.accountTeamMembers, connectLoggedInContactId);
      setChangedMembers(changed);
    }
  }, [teamMembersData, formValues.accountTeamMembers, connectLoggedInContactId]);

  // Define columns for the team members table
  const teamMembersColumns = [
    {
      title: 'Name',
      dataIndex: 'DisplayName',
      key: 'DisplayName',
    },
    {
      title: 'Email',
      dataIndex: 'EmailAddress',
      key: 'EmailAddress',
    },
    {
      title: 'View Reports',
      dataIndex: 'IsViewReports',
      key: 'IsViewReports',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Enter Transactions',
      dataIndex: 'IsEnterTransactions',
      key: 'IsEnterTransactions',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Modify Banking Instructions',
      dataIndex: 'IsModifyBankingInstructions',
      key: 'IsModifyBankingInstructions',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Close Accounts',
      dataIndex: 'IsCloseAccounts',
      key: 'IsCloseAccounts',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Manage Users',
      dataIndex: 'IsManageUsers',
      key: 'IsManageUsers',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Statement Recipient',
      dataIndex: 'IsStatementRecipient',
      key: 'IsStatementRecipient',
      render: (value) => (value ? 'Yes' : 'No'),
    },       
  
  ];

  if(programId === 44){
    // Specific logic for programId 44(PLGIT)
    teamMembersColumns.push(
      {
        title: 'Check Verifier',
        dataIndex: 'IsCheckVerifier',
        key: 'IsCheckVerifier',
        render: (value) => (value ? 'Yes' : 'No'),
      }
    );  
  }


  const accountOptionsLabel = (val) => {
   if(accountOptions && accountOptions.length > 0){
    const account = accountOptions.find(option => String(option.value) === String(val));
    return account ? account.label : val;
   }
  };

  return (
    <StyledReviewForm>
      {/* Account Details Section */}
      <div className="section-box">
        <Box display="flex" justifycontent="flex-end">
          <ButtonAnt
            type="link"
            label="Edit"
            icon={<EditOutlined />}
            onClick={() => {
              setAccountTitleMsg('');
              setAccountTitleStatus(null)
              setCurrentStepNumber(0);
            }}
          />
        </Box>

        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p className="section-title">Account Title:</p>
            <p>{formValues?.accTitle}</p>
          </Col>
          <Col span={24}>
            <p className="section-title">Bond Proceeds:</p>
            <p>{formValues?.isAccBonds}</p>
          </Col>
          <Col span={24}>
            <p className="section-title">Dividend Account:</p>
            <p>{formValues.additionalAccTitle != null
              ? formValues.additionalAccTitle
              : formValues.paidDividendsAccount == 0
                ? 'This Account'
                : accountOptionsLabel(formValues.paidDividendsAccount)}</p>
          </Col>
          <Col span={24}>
        <p className="section-title">Investment Options:</p>
        <p>
          {Array.isArray(formValues.mvarIsAccBonds) && formValues.mvarIsAccBonds.flat().map(id => {
            const fund = investmentOptions.find(opt => String(opt.value) === String(id));
            return fund ? fund.label : id;
          }).join(', ')}
        </p>
          </Col>
        </Row>
      </div>

      {/* Team Members Section */}
     {changedMembers.length > 0 && <div className="section-box">
        <Box display="flex" justifycontent="flex-end">
          <ButtonAnt
            type="link"
            label="Edit"
            icon={<EditOutlined />}
            onClick={() => setCurrentStepNumber(2)}
          />
        </Box>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p className="section-title">Team Members:</p>
            <Table
              dataSource={changedMembers}
              columns={teamMembersColumns}
              pagination={false}
              bordered
            />
          </Col>
        </Row>
      </div>}
    </StyledReviewForm>
  );
};

export default ReviewAccountForm;